import api from './api';

export default {
  getActivity({ activityId }) {
    return api.get(`/quizes/api/v1/activities/last/${activityId}`);
  },
};
